import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../emotion-theme";

const widthPercent = 35;
const animate = (name: string) => `animation: ${name} 0.25s ease`;

const expanded = `
  z-index: 100;
  background-color: ${BASE_COLORS.white};
  min-width: 100%;
  &.open {
    box-shadow: none;
  }
`;

export const HostContainer = styled.div`
  visibility: hidden;
  min-height: 100%;
  width: 0;
  margin: 0;

  &.expanded {
    ${expanded}
  }

  &.open,
  &.closed {
    visibility: visible;
  }

  &.open {
    ${animate("slideIn")};
    box-shadow: -10px 0 20px 5px ${BASE_COLORS.lightGrey};
    width: ${widthPercent}%;
    opacity: 100%;

    @keyframes slideIn {
      from {
        width: 0;
      }
      to {
        width: ${widthPercent}%;
      }
      0% {
        opacity: 0;
      }
      75% {
        opacity: 25%;
      }
      85% {
        opacity: 50%;
      }
      100% {
        opacity: 100%;
      }
    }
  }

  &.closed {
    ${animate("slideOut")};
    animation-fill-mode: forwards;

    @keyframes slideOut {
      from {
        width: ${widthPercent}%;
        opacity: 100%;
      }
      to {
        width: 0;
        opacity: 0;
      }
      100% {
        visibility: hidden;
      }
    }
  }
`;

export const DrawerContent = styled.div`
  position: relative;
  min-width: 100%;
  padding: 20px;
`;
